(function(window, document) {
  'use strict';

  function markDecorativeFooterIcons() {
    document.querySelectorAll('.custom-footer .footer-contact svg, .custom-footer .material-icons').forEach(function(icon) {
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDecorativeFooterIcons, { once: true });
  } else {
    markDecorativeFooterIcons();
  }
})(window, document);
